import React from "react";
import { Wrapper } from "./style";

const RootLoading = () => {
  return (
    <Wrapper>
      <div className="item">
        <div className="loader-pulse" />
      </div>
    </Wrapper>
  );
};

export default RootLoading;
